exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-01db1f02] {\n  font-weight: normal !important;\n}", ""]);

// exports
